import { HS_PASTE_IMAGE_IDENTIFIER, HS_PASTE_HR_IDENTIFIER } from '../constants/paste';
import parseHTML from '../utils/parseHTML';
import { converterNames } from './pastePreProcess';
export const getTagNameTextConverter = (startTextIdentifier, constructConvertNode) => html => {
  const doc = parseHTML(html);
  Array.from(doc.getElementsByTagName('EM')).forEach(node => {
    if (node.textContent && node.textContent.startsWith(startTextIdentifier) && node.parentNode) {
      node.parentNode.replaceChild(constructConvertNode(node), node);
    }
  });
  return doc.outerHTML;
};
const constructImageTextConvertNode = node => {
  const newNode = document.createElement('IMG');
  if (node.dataset.imgAttributes) {
    const imgAttributes = JSON.parse(node.dataset.imgAttributes);
    newNode.setAttribute('src', imgAttributes.src);
    newNode.setAttribute('width', imgAttributes.width);
    newNode.setAttribute('height', imgAttributes.height);
  }
  return newNode;
};
const constructImgAttributeText = element => {
  return JSON.stringify({
    src: element.src,
    width: element.width,
    height: element.height
  });
};
const updateImgReplaceElement = (element, newChild) => {
  newChild.innerHTML = HS_PASTE_IMAGE_IDENTIFIER;
  newChild.dataset.imgAttributes = constructImgAttributeText(element);
};
const updateHrRelplaceElement = (element, newChild) => {
  newChild.innerHTML = HS_PASTE_HR_IDENTIFIER;
};
export const getTagNameTextTransformer = (tagName, updateReplaceElement) => doc => {
  Array.from(doc.getElementsByTagName(tagName)).forEach(element => {
    const newChild = document.createElement('EM');
    updateReplaceElement(element, newChild);
    if (element.parentNode) {
      element.parentNode.replaceChild(newChild, element);
    }
  });
};
export const backgroundColorTransformer = doc => {
  Array.from(doc.getElementsByTagName('span')).forEach(element => {
    const backgroundStyle = element.style.background;
    if (backgroundStyle) {
      element.style.removeProperty('background');
      element.style.backgroundColor = backgroundStyle;
    }
  });
};
export const wordCommentContinuationTransformer = doc => {
  Array.from(doc.getElementsByTagName('span')).forEach(element => {
    if (element.hasAttribute('style') &&
    //@ts-expect-error we know style exists but ts cant recognize that fact
    element.getAttribute('style').includes('mso-comment-continuation')) {
      element.removeAttribute('style');
    }
  });
};
export const getPastePreProcessHtmlTransforms = converterName => {
  const transformers = [];
  const converters = [];
  switch (converterName) {
    case converterNames.CONVERT_GOOGLE_TO_HTML:
      transformers.push(
      //@ts-expect-error this is not accepting a more generic version of the element
      getTagNameTextTransformer('img', updateImgReplaceElement),
      //@ts-expect-error this is not accepting a more generic version of the element
      getTagNameTextTransformer('hr', updateHrRelplaceElement));
      converters.push(getTagNameTextConverter(HS_PASTE_IMAGE_IDENTIFIER,
      //@ts-expect-error this is not accepting a more generic version of the element
      constructImageTextConvertNode), getTagNameTextConverter(HS_PASTE_HR_IDENTIFIER, () => document.createElement('HR')));
      break;
    case converterNames.CONVERT_MSWORD_TO_HTML:
      transformers.push(backgroundColorTransformer);
      transformers.push(wordCommentContinuationTransformer);
      break;
    default:
      break;
  }
  return {
    transformers,
    converters
  };
};
export const transformHtml = (html, transformers) => {
  const doc = parseHTML(html);
  transformers.forEach(transformer => {
    transformer(doc);
  });
  return doc.innerHTML;
};